import {
    GET_REFERRAL_CONTENT,
    GET_ALL_REFERRAL_CONTENTS,
    GET_REFERRAL_CONTENT_REQUEST,
    CREATE_REFERRAL_CONTENT,
    UPDATE_REFERRAL_CONTENT,
    DELETE_REFERRAL_CONTENT,
    CLEAR_REFERRAL_CONTENT
} from '../actions/types';

const initialState = {
    referralContents: [],
    referralContent: null,
    assetPath: '',
    loading: true
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case CREATE_REFERRAL_CONTENT:
            return {
                ...state,
                referralContents: [...state.referralContents, payload.content || payload],
                assetPath: payload.assetPath || state.assetPath,
                loading: false
            };
        case GET_ALL_REFERRAL_CONTENTS:
            return {
                ...state,
                referralContents: payload.content,
                assetPath: payload.assetPath,
                loading: false
            };
        case GET_REFERRAL_CONTENT:
            return {
                ...state,
                referralContent: payload.content || payload,
                assetPath: payload.assetPath || state.assetPath,
                loading: false
            };
        case GET_REFERRAL_CONTENT_REQUEST:
            return {
                ...state,
                loading: payload
            };
        case UPDATE_REFERRAL_CONTENT:
            return {
                ...state,
                referralContents: state.referralContents.map(content =>
                    content._id === (payload.content || payload)._id ? (payload.content || payload) : content
                ),
                referralContent: payload.content || payload,
                assetPath: payload.assetPath || state.assetPath,
                loading: false
            };
        case DELETE_REFERRAL_CONTENT:
            return {
                ...state,
                referralContents: state.referralContents.filter(content => content._id !== payload),
                loading: false
            };
        case CLEAR_REFERRAL_CONTENT:
            return {
                ...state,
                referralContent: null,
                loading: false
            };
        default:
            return state;
    }
}; 